import { useFlags } from '@joor/launchdarkly-react-client-sdk'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { isAccountTypeRetailer, isLiteBrand } from 'store/currentUser/selectors'

import {
  CONNECTION_REQUESTS,
  CURRENT_CONNECTIONS,
  FIND_NEW_RETAILERS,
  PENDING_CONNECTIONS,
  PROSPECTS,
} from 'routes/paths'

import DropdownMenuGroup from '../DropdownMenuGroup/DropdownMenuGroup'
import DropdownMenuTextLink from '../DropdownMenuTextLink/DropdownMenuTextLink'
import NavbarDropdown from '../NavbarDropdown/NavbarDropdown'
import Trigger from '../Trigger/Trigger'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { ConnectionsDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'
import { IConnectionsDropdownSelectors } from 'features/Navbar/NavbarRevamp/navbarRevamp.types'

const NavbarConnectionsDropdownContainer = styled.div`
  display: flex;
`

const ProBrandConnections = ({ prospectsFlag }: { prospectsFlag: boolean }) => (
  <DropdownMenuGroup>
    {prospectsFlag && (
      <>
        <DropdownMenuTextLink
          to={FIND_NEW_RETAILERS}
          message={messages.findNewRetailers}
          id={ConnectionsDropdownIds.ConnectionOptionsFindRetailers}
          testId={ConnectionsDropdownIds.ConnectionOptionsFindRetailers}
        />
        <DropdownMenuTextLink
          to={PROSPECTS}
          message={messages.prospects}
          id={ConnectionsDropdownIds.Prospects}
          testId={ConnectionsDropdownIds.Prospects}
        />{' '}
      </>
    )}
    <DropdownMenuTextLink
      to={CURRENT_CONNECTIONS}
      message={messages.manageConnections}
      id={ConnectionsDropdownIds.ConnectionOptionsManage}
      testId={ConnectionsDropdownIds.ConnectionOptionsManage}
    />
    <DropdownMenuTextLink
      to={CONNECTION_REQUESTS}
      message={messages.connectionsRequests}
      id={ConnectionsDropdownIds.ConnectionOptionsRequests}
      testId={ConnectionsDropdownIds.ConnectionOptionsRequests}
    />
    <DropdownMenuTextLink
      to={PENDING_CONNECTIONS}
      message={messages.pendingConnections}
      id={ConnectionsDropdownIds.ConnectionOptionsPending}
      testId={ConnectionsDropdownIds.ConnectionOptionsPending}
    />
    {!prospectsFlag && (
      <DropdownMenuTextLink
        to={FIND_NEW_RETAILERS}
        message={messages.findNewRetailers}
        id={ConnectionsDropdownIds.ConnectionOptionsFindRetailers}
        testId={ConnectionsDropdownIds.ConnectionOptionsFindRetailers}
      />
    )}
  </DropdownMenuGroup>
)

const LiteBrandConnections = () => (
  <DropdownMenuGroup>
    <DropdownMenuTextLink
      to={CURRENT_CONNECTIONS}
      message={messages.myConnections}
      id={ConnectionsDropdownIds.ConnectionOptionsManage}
      testId={ConnectionsDropdownIds.ConnectionOptionsManage}
    />
    <DropdownMenuTextLink
      to={CONNECTION_REQUESTS}
      message={messages.connectionsRequests}
      id={ConnectionsDropdownIds.ConnectionOptionsRequests}
      testId={ConnectionsDropdownIds.ConnectionOptionsRequests}
    />
  </DropdownMenuGroup>
)

const RetailerConnections = () => (
  <NavbarConnectionsDropdownContainer>
    <NavbarDropdown
      trigger={
        <Trigger
          label={messages.connections}
          id={ConnectionsDropdownIds.ConnectionTrigger}
        />
      }
    >
      <DropdownMenuGroup>
        <DropdownMenuTextLink
          to={CURRENT_CONNECTIONS}
          message={messages.manageConnections}
          id={ConnectionsDropdownIds.ConnectionOptionsManage}
          testId={ConnectionsDropdownIds.ConnectionOptionsManage}
        />
        <DropdownMenuTextLink
          to={PENDING_CONNECTIONS}
          message={messages.pendingConnections}
          id={ConnectionsDropdownIds.ConnectionOptionsRequests}
          testId={ConnectionsDropdownIds.ConnectionOptionsRequests}
        />
      </DropdownMenuGroup>
    </NavbarDropdown>
  </NavbarConnectionsDropdownContainer>
)

const NavbarConnectionsDropdown = () => {
  const { isRetailerAccount, isLiteBrandAccount } = useSelector<
    object,
    IConnectionsDropdownSelectors
  >((state) => ({
    isRetailerAccount: isAccountTypeRetailer(state),
    isLiteBrandAccount: isLiteBrand(state),
  }))
  const { prospects } = useFlags()
  if (isRetailerAccount) {
    return <RetailerConnections />
  }

  return (
    <NavbarConnectionsDropdownContainer>
      <NavbarDropdown
        trigger={
          <Trigger
            label={prospects ? messages.retailers : messages.connections}
            id={ConnectionsDropdownIds.ConnectionTrigger}
          />
        }
      >
        {isLiteBrandAccount ? (
          <LiteBrandConnections />
        ) : (
          <ProBrandConnections prospectsFlag={prospects} />
        )}
      </NavbarDropdown>
    </NavbarConnectionsDropdownContainer>
  )
}

export default NavbarConnectionsDropdown
